module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"yearsOld":"წლის","male":"მამრ","female":"მდედრ","countryGE":"საქართველო","languageka":"ქართული"}}')
  delete Component.options._Ctor
}
